/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Publish_NoteInputs */

const en_mk_publish_note = /** @type {(inputs: Mk_Publish_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publishing depends on project readiness and hosting limits. Local projects use your own hosting provider.`)
};

const id_mk_publish_note = /** @type {(inputs: Mk_Publish_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ketersediaan penerbitan mengikuti kesiapan proyek dan batas hosting. Proyek mandiri memakai layanan hosting pilihanmu.`)
};

/**
* | output |
* | --- |
* | "Publishing depends on project readiness and hosting limits. Local projects use your own hosting provider." |
*
* @param {Mk_Publish_NoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_publish_note = /** @type {((inputs?: Mk_Publish_NoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Publish_NoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_publish_note(inputs)
	return en_mk_publish_note(inputs)
});